import React, { useEffect, useState } from "react";
import "./Style.css";
import { useAxios } from "../../../hooks/useAxios";

/*---------------------- Mui Components --------------------------*/

import { Box, Paper } from "@mui/material";
import { useLoading } from "../../../context/dashboardLoading";
import SmallLoader from "./SmallLoader";

const PerformanceHome = (props) => {
  const { isLoading } = useLoading();
  const { axios } = useAxios();
  const { hospitalFilter } = props;
  const [performanceIndicatingUnit, setPerformanceIndicator] = React.useState();

  useEffect(() => {
    performanceIndicator();
  }, [hospitalFilter]);

  const performanceIndicator = async () => {
    await axios
      .post(`getAvgPerformancePerDayDetail`, hospitalFilter)
      .then((data) => {
        setPerformanceIndicator(data.data.result);
      });
  };

  // NEW: Fixed-height value wrapper for neat UI
  const ValueBox = ({ children }) => (
    <div
      style={{
        height: "3.2rem",      // keeps height same even during loading
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "0.6rem",
      }}
    >
      {children}
    </div>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        "& > :not(style)": {
          mt: 1,
          mb: 1,
          width: "23%",
          height: "18vh",
        },
      }}
    >
      {/* ------------------ Box 1 ------------------ */}
      <Paper elevation={15} style={{ backgroundColor: "#FFDC00" }}>
        <div className="performance-content">
          <p style={{ fontSize: "1.2rem" }}>Avg. Household Survey done</p>

          <ValueBox>
            {isLoading ? (
              <SmallLoader />
            ) : (
              <span style={{ fontSize: "1.8rem" }}>
                {Math.round(performanceIndicatingUnit?.Avg_household_per_day || 0)}
              </span>
            )}
          </ValueBox>
        </div>
      </Paper>

      {/* ------------------ Box 2 ------------------ */}
      <Paper elevation={15} style={{ backgroundColor: "#6CE1CB" }}>
        <div className="performance-content">
          <p style={{ fontSize: "1.2rem" }}>Avg. Distance Travelled</p>

          <ValueBox>
            {isLoading ? (
              <SmallLoader />
            ) : (
              <span style={{ fontSize: "1.8rem" }}>
                {performanceIndicatingUnit?.distanceAvg
                  ? Math.round(performanceIndicatingUnit.distanceAvg)
                  : 0}{" "}
                km
              </span>
            )}
          </ValueBox>
        </div>
      </Paper>

      {/* ------------------ Box 3 ------------------ */}
      <Paper elevation={15} style={{ backgroundColor: "#92D050" }}>
        <div className="performance-content">
          <p style={{ fontSize: "1.1rem" }}>
            Avg. No. of Individuals Screened
          </p>

          <ValueBox>
            {isLoading ? (
              <SmallLoader />
            ) : (
              <span style={{ fontSize: "1.8rem" }}>
                {performanceIndicatingUnit?.Avg_individual_screened_per_day
                  ? Math.round(
                      performanceIndicatingUnit.Avg_individual_screened_per_day
                    )
                  : 0}
              </span>
            )}
          </ValueBox>
        </div>
      </Paper>

      {/* ------------------ Box 4 ------------------ */}
      <Paper elevation={15} style={{ backgroundColor: "#E2E214" }}>
        <div className="performance-content">
          <p style={{ fontSize: "1.2rem" }}>Avg. Yellow Card Issued</p>

          <ValueBox>
            {isLoading ? (
              <SmallLoader />
            ) : (
              <span style={{ fontSize: "1.8rem" }}>
                {performanceIndicatingUnit?.Avg_yellocard_per_day
                  ? Math.round(performanceIndicatingUnit.Avg_yellocard_per_day)
                  : 0}
              </span>
            )}
          </ValueBox>
        </div>
      </Paper>
    </Box>
  );
};

export default PerformanceHome;
